import 'angular:locale/data:en-US';
import './apps/orgbrain/src/polyfills.ts';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-US";
